import { type SystemTemplateType } from './types';

export type StorageType = {
  exists: () => boolean;
  getTemplateType: () => SystemTemplateType | null;
  remove: () => void;
};

const LS_TEMPLATE_KEY = 'databases-create-with-template-type';

export const storage: StorageType = {
  exists: () => {
    return Boolean(localStorage.getItem(LS_TEMPLATE_KEY));
  },
  getTemplateType: () => {
    return localStorage.getItem(LS_TEMPLATE_KEY) as SystemTemplateType | null;
  },
  remove: () => {
    localStorage.removeItem(LS_TEMPLATE_KEY);
  },
};
